export const newsletter = {
  newsletter: {
    title: 'Fast geschafft!',
    subTitle:
      'Schau in deinen Posteingang. Wir haben dir eine <br/> E-Mail zur Bestätigung deiner E-Mail-Adresse geschickt.',
    steps: {
      stepOne: {
        title: '1. E-Mail öffnen',
        info: 'Bitte schaue in deinem E-Mail-Postfach nach.',
      },
      stepTwo: {
        title: '2. Anmeldung bestätigen',
        info: 'Klicke den Link in der Mail an, um deine Anmeldung zu bestätigen.',
      },
      stepThree: {
        title: '3. Exklusive Vorteile genießen',
        info: 'Als Newsletter-Leser profitierst du von exklusiven vorab Informationen, attraktiven Angeboten & praktischen Tipps rund ums Familien-Leben.',
      },
    },
    unsubscribeSuccess: 'Du wurdest erfolgreich von unserem Newsletter abgemeldet.',
    noEmail: 'Keine E-Mail erhalten?',
    noEmailDescription:
      'Es kann sein, dass die E-Mail in deinem Spam-Ordner gelandet ist. <br /> Am besten schaue in allen Ordnern nach oder wende dich an: ',
    habaServiceMailAddress: '<u>kundenservice@haba.de</u>',
    tips: 'Unser Tipp',
    tipsDescription:
      'Füge die Absender-Adresse unseres Newsletter gleich zu deinem persönlichen Adressbuch hinzu, um die Newsletter korrekt empfangen zu können. <br /><br /> In deine E-Mail-Adresse hat sich ein Fehler eingeschlichen? <br /> Dann kannst du sie neu eingeben.',
  },
};
